import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import appConfig from "configs/app.config";
import useAuth from "utils/hooks/useAuth";
import getDomain from "utils/getDomain";
import { xiaomiDomains } from "constants/moduleConstants/domain.constant";

const PublicRoute = () => {
  const { authenticated } = useAuth();
  const domain = getDomain().toLowerCase();
  const entryPath = xiaomiDomains.includes(domain)
    ? "/user-wastes/waste-list/add-waste"
    : appConfig.authenticatedEntryPath;

  return authenticated ? <Navigate to={entryPath} /> : <Outlet />;
};

export default PublicRoute;
